module.exports = __webpack_public_path__ + "img/right_arrow.ff2b9671.svg";